import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useHistory } from 'react-router-dom';
import { connect } from 'react-redux';
import * as actions from '../actions/index';

const ContactForm = ({ onSubmitContact }) => {    
    const [submitStatus, setSubmitStatus] = useState('');
    const history = useHistory();
    
    const { 
        register, 
        handleSubmit, 
        formState: { errors, isSubmitting, isValid },
        reset
    } = useForm({
        mode: 'onChange'
    });

    const onSubmit = async (data) => {
        try {
            setSubmitStatus('submitting');
            await onSubmitContact(data);
            reset(); // Clear the form
            // Redirect to confirmation page on success
            history.push('/contact/confirmation');
        } catch (error) {
            console.error('Contact form submission error:', error);
            setSubmitStatus('error');
        }
    };

    return (
        <div style={{
            background: 'linear-gradient(135deg, rgba(255,255,255,0.9) 0%, rgba(248,250,252,0.9) 100%)',
            borderRadius: '16px',
            padding: '3rem',
            boxShadow: '0 10px 25px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05)',
            border: 'none'
        }}>
            {errors.submit && (
                <div className="alert alert-danger mb-4" style={{
                    borderRadius: '8px',
                    border: 'none',
                    backgroundColor: '#fed7d7',
                    color: '#c53030'
                }}>
                    {errors.submit.message}
                </div>
            )}
            
            <form onSubmit={handleSubmit(onSubmit)}>
                {/* Name Field */}
                <div className="mb-4">
                    <input
                        className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                        {...register("name", { 
                            required: "Name is required",
                            minLength: {
                                value: 2,
                                message: "Name must be at least 2 characters"
                            }
                        })}
                        type="text"
                        placeholder="Your full name"
                        autoComplete="name"
                        style={{
                            height: '50px',
                            borderRadius: '8px',
                            border: '2px solid #e2e8f0',
                            fontSize: '1rem',
                            fontFamily: '"Inter", "Segoe UI", system-ui, sans-serif',
                            padding: '0 16px',
                            transition: 'border-color 0.2s ease'
                        }}
                    />
                    {errors.name && (
                        <div className="invalid-feedback" style={{ fontSize: '0.875rem', marginTop: '0.25rem' }}>
                            {errors.name.message}
                        </div>
                    )}
                </div>

                {/* Email Field */}
                <div className="mb-4">
                    <input
                        className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                        {...register("email", { 
                            required: "Email is required",
                            pattern: {
                                value: /^[a-zA-Z0-9.!#$%*/?^_`{|}~-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]{2,}$/,
                                message: "Invalid email address"
                            }
                        })}
                        type="email"
                        placeholder="your.email@example.com"
                        autoComplete="email"
                        style={{
                            height: '50px',
                            borderRadius: '8px',
                            border: '2px solid #e2e8f0',
                            fontSize: '1rem',
                            fontFamily: '"Inter", "Segoe UI", system-ui, sans-serif',
                            padding: '0 16px',
                            transition: 'border-color 0.2s ease'
                        }}
                    />
                    {errors.email && (
                        <div className="invalid-feedback" style={{ fontSize: '0.875rem', marginTop: '0.25rem' }}>
                            {errors.email.message}
                        </div>
                    )}
                </div>

                {/* Message Field */}
                <div className="mb-5">
                    <textarea
                        className={`form-control ${errors.message ? 'is-invalid' : ''}`}
                        {...register("message", { 
                            required: "Message is required",
                            minLength: {
                                value: 10,
                                message: "Message must be at least 10 characters"
                            }
                        })}
                        placeholder="Tell me about your project, goals, or how I can help..."
                        rows="6"
                        style={{
                            borderRadius: '8px',
                            border: '2px solid #e2e8f0',
                            fontSize: '1rem',
                            fontFamily: '"Inter", "Segoe UI", system-ui, sans-serif',
                            padding: '16px',
                            resize: 'vertical',
                            transition: 'border-color 0.2s ease'
                        }}
                    />
                    {errors.message && (
                        <div className="invalid-feedback" style={{ fontSize: '0.875rem', marginTop: '0.25rem' }}>
                            {errors.message.message}
                        </div>
                    )}
                </div>

                {/* Submit Button */}
                <div className="text-center">
                    <button 
                        type="submit"
                        style={{ 
                            backgroundColor: '#667eea',
                            color: '#ffffff',
                            border: 'none',
                            borderRadius: '8px',
                            padding: '14px 32px',
                            fontSize: '1rem',
                            fontWeight: '500',
                            fontFamily: '"Inter", "Segoe UI", system-ui, sans-serif',
                            cursor: 'pointer',
                            transition: 'all 0.2s ease',
                            minWidth: '160px',
                            opacity: (!isValid || isSubmitting || submitStatus === 'submitting') ? 0.6 : 1
                        }} 
                        disabled={!isValid || isSubmitting || submitStatus === 'submitting'}
                        onMouseOver={(e) => {
                            if (!e.target.disabled) {
                                e.target.style.backgroundColor = '#5a67d8';
                                e.target.style.transform = 'translateY(-1px)';
                            }
                        }}
                        onMouseOut={(e) => {
                            if (!e.target.disabled) {
                                e.target.style.backgroundColor = '#667eea';
                                e.target.style.transform = 'translateY(0)';
                            }
                        }}
                    >
                        {submitStatus === 'submitting' ? 'Sending...' : 'Send Message'}
                    </button>
                </div>

                {/* Error Message */}
                {submitStatus === 'error' && (
                    <div className="mt-4 text-center">
                        <div style={{
                            backgroundColor: '#fed7d7',
                            color: '#c53030',
                            padding: '16px 24px',
                            borderRadius: '8px',
                            border: 'none',
                            fontSize: '0.95rem',
                            fontFamily: '"Inter", "Segoe UI", system-ui, sans-serif'
                        }}>
                            <strong>Error sending message.</strong> Please try again or contact me directly at elliot@elliotkoss.com.
                        </div>
                    </div>
                )}
            </form>
        </div>
    );
};

function mapStateToProps(state) {
    return {
        enableReinitialize: true,
    };
}

export default connect(mapStateToProps, actions)(ContactForm);
